import { render } from "./AddRoute.vue?vue&type=template&id=4fdcf717"
import script from "./AddRoute.vue?vue&type=script&lang=js"
export * from "./AddRoute.vue?vue&type=script&lang=js"
script.render = render

export default script